module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "py-3"
  }, [_vm._v("Communication")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', [_vm._v("Notification Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-10 pl-0"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.emailList,
      "label": "emailOption",
      "placeholder": "Select an option",
      "append-to-body": true,
      "value": _vm.emailSelection
    },
    on: {
      "input": _vm.changeStatusSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [(_vm.emailSelection.emailType === 'EventCancelRiskGroup' || _vm.emailSelection.emailType === 'EventWarningRiskGroup') ? _c('span', {
    staticClass: "color-1 fs-small"
  }, [_vm._v("\n                Emails will be sent to customers whose reservations are in "), _c('strong', [_vm._v("booked")]), _vm._v(", "), _c('strong', [_vm._v("rebooked")]), _vm._v(", or "), _c('strong', [_vm._v("pending")]), _vm._v(" status.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.emailSelection.emailType === 'EventPendingInformation') ? _c('span', {
    staticClass: "color-1 fs-small"
  }, [_vm._v("\n                Emails will be sent to customers whose reservations are in "), _c('strong', [_vm._v("pending")]), _vm._v(" status.\n            ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-2"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Notify customers by email ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a239d45"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaCommunication.vue
// module id = 1332
// module chunks = 0